/**
 * 降级数据配置
 * 当API不可用时使用这些默认值
 */

import type { GameSummary } from '../api/types';

/**
 * 默认推荐游戏
 * 当获取推荐失败时使用
 */
export const FALLBACK_FEATURED_GAMES: GameSummary[] = [
  {
    id: 'ys',
    name: 'ys',
    title: '原神官orB',
    slug: 'ys',
    cover: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game/20231108082/20231108082934684_mgwebp0.webp',
    icon: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game/20231108082/20231108082934684_mgwebp0.webp',
    tags: ['二次元', '开放世界'],
    category: 'rpg',
    platforms: [{ id: 'migufun', name: '咪咕快游', status: 'active' }],
    viewCount: 99999,
  },
  {
    id: 'bhxqtd',
    name: 'bhxqtd',
    title: '崩坏：星穹铁道',
    slug: 'bhxqtd',
    cover: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202312/2709/45/20231227094540685_mgwebp1_1284x2778.webp',
    icon: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game/20230423133/20230423133918142.png',
    tags: ['二次元', '回合制'],
    category: 'rpg',
    platforms: [{ id: 'migufun', name: '咪咕快游', status: 'active' }],
    viewCount: 88888,
  },
  {
    id: 'bh3',
    name: 'bh3',
    title: '崩坏3',
    slug: 'bh3',
    cover: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202402/0110/05/20240201100501478_mgwebp1.webp',
    icon: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202402/0110/09/20240201100913306_mgwebp0.webp',
    tags: ['二次元', '动作'],
    category: 'action',
    platforms: [{ id: 'migufun', name: '咪咕快游', status: 'active' }],
    viewCount: 77777,
  },
  {
    id: 'jq0',
    name: 'jq0',
    title: '绝区零',
    slug: 'jq0',
    cover: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202407/0215/15/20240702151535752_mgwebp1.webp',
    icon: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202407/0215/14/20240702151455081_mgwebp1.webp',
    tags: ['二次元', '动作'],
    category: 'action',
    platforms: [{ id: 'migufun', name: '咪咕快游', status: 'active' }],
    viewCount: 66666,
  },
  {
    id: 'dwrg',
    name: 'dwrg',
    title: '第五人格',
    slug: 'dwrg',
    cover: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202401/0314/32/20240103143255984_mgwebp1.webp',
    icon: 'https://gcache.migu.cn/prod/upload/game_resource/channel_for_homepage_game2/202401/0314/23/20240103142333341_mgwebp1.webp',
    tags: ['竞技', '非对称'],
    category: 'casual',
    platforms: [{ id: 'migufun', name: '咪咕快游', status: 'active' }],
    viewCount: 55555,
  },
];

/**
 * 热门搜索词
 * 用于搜索建议降级方案
 */
export const HOT_SEARCH_TERMS = [
  '原神',
  '崩坏：星穹铁道',
  '崩坏3',
  '绝区零',
  '第五人格',
  '元气骑士',
  '蔚蓝档案',
  '崩坏学园2',
];

/**
 * 下载链接配置
 * 现在硬编码，以后从API获取
 */
export interface DownloadLinks {
  android: string | null;
  ios: string | null;
  windows: string | null;
}

export const FALLBACK_DOWNLOAD_LINKS: DownloadLinks = {
  android: null, // 'https://example.com/app.apk'
  ios: null,
  windows: null,
};

/**
 * 平台图标映射
 * 当API返回的icon为空时使用
 */
export const PLATFORM_ICON_MAP: Record<string, string> = {
  migufun: 'cloud',
  tenstart: 'gamepad-2',
  jiyoushe: 'smartphone',
};

/**
 * 分类图标映射
 * 增强分类的视觉效果
 */
export const CATEGORY_ICON_MAP: Record<string, string> = {
  rpg: 'sword',
  action: 'zap',
  strategy: 'brain',
  casual: 'coffee',
  sports: 'trophy',
  racing: 'car',
  shooting: 'target',
};

/**
 * 标签图标映射
 */
export const TAG_ICON_MAP: Record<string, string> = {
  '二次元': 'sparkles',
  '竞技': 'trophy',
  '休闲': 'coffee',
  '动作': 'zap',
  '策略': 'brain',
};
